import { gql } from "@apollo/client";

const AvailableDevicesSubscription = gql`
  subscription AvailableDevices {
    listen(topic: "device_update") {
      query {
        allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
          nodes {
            id
            latitudeField
            longitudeField
            altitudeField
            headingField
            orientedImageryType
            timeField
            timestampFormat
            deviceName
            dateTimeField
            dateField
            fileFormat
          }
        }
      }
    }
  }
`;

const hash = "d5d6f1bb2233617d0a8936a7d5f5507f06e1f9b9c9a744019000f27c7cf531bd";

export { AvailableDevicesSubscription, hash };
